import { render, staticRenderFns } from "./MainzLevel.vue?vue&type=template&id=32320080&scoped=true&"
import script from "./MainzLevel.vue?vue&type=script&lang=js&"
export * from "./MainzLevel.vue?vue&type=script&lang=js&"
import style0 from "./MainzLevel.vue?vue&type=style&index=0&id=32320080&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32320080",
  null
  
)

export default component.exports